import React, { useState, useEffect } from "react";
import ActiverentCom from "./ActiverentCom";
import getServices from "../../Services/get-service";
import Skeleton from "@mui/material/Skeleton";
import Note from "../../Assets/images/note.svg";

function Activerent() {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getServices.getActiveRentals()
      .then((response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          const rentalsData = response.data.data || [];
          setRentals(Array.isArray(rentalsData) ? rentalsData : []);  
        }
      })
      .catch((error) => {
        setLoading(false);
        // console.log(error);
      });
  }, []);

  return (
    <div className=" pt-4">
      {loading ? (
        [1, 2, 3].map((item) => (
          <div key={item} className=" my-3 border-gray-200 border rounded p-3">
            <Skeleton variant="rectangular" height={100} width="100%" />
          </div>
        ))
      ) : rentals.length < 1 ? (
        <div className="flex flex-col items-center justify-center py-10">
          <img src={Note} alt="No rentals" className="mb-4 w-16 h-16" />
          <p className="text-center text-gray-500 font-medium">
            No active rent yet.
          </p>
        </div>
      ) : (
        rentals.map((rental, i) => <ActiverentCom key={i} rental={rental} />)
      )}
    </div>
  );
}

export default Activerent;
